module.exports = __webpack_public_path__ + "img/giant_spider_small.30c2e89f.png";